import Backbone from 'backbone';

export default Backbone.Model.extend({
  defaults: {
    command: '',
    attributes: {}
  }
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/dom_components/model/ToolbarButton.js